import type { SortType } from 'rsuite-table'
import type { SortOrderDirection } from '@@partner:types:graphql'

import { SORT_ORDER_DESC, SORT_ORDER_ASC } from '@@partner:config/graphql'

export const sortOrderDirectionToSortType = (
  direction: SortOrderDirection
): SortType => (direction === SORT_ORDER_DESC ? 'desc' : 'asc')

export const sortTypeToSortOrderDirection = (
  sortType: SortType
): SortOrderDirection => (sortType === 'asc' ? SORT_ORDER_ASC : SORT_ORDER_DESC)
